"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PURCHASE_ORDER_MODEL = void 0;
exports.PURCHASE_ORDER_MODEL = "purchase-orders";
